<div class="px-3 py-5">
    <div class="theme-container">
        <mat-card class="p-0 o-hidden">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="p-0" [style.background-image]="bgImage" class="bg-cover">
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3" ngClass.gt-sm="px-5" ngClass.sm="px-3"
                    ngClass.xs="px-3">
                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
                        <h1 class="secondary-font">Creer votre Compte</h1>
                        <a mat-button routerLink="/login" color="accent" class="w-100">Avez déjà un compte ?
                            S'identifier!
                        </a>
                    </div>
                    <form [formGroup]="CreateUtilisateurForm" (ngSubmit)="onCreateUtilisateurFormSubmit()">
                        
                        <mat-form-field appearance="outline" class="w-100 mt-1">
                            <!-- <mat-icon matPrefix class="mr-1 text-muted">email</mat-icon>
                            <mat-label>Email ou N° de telephone</mat-label> -->

                            
                            <mat-label> 
                                <mat-icon matPrefix class="mr-1 text-muted">email</mat-icon>
                                Email / 
                                <mat-icon matPrefix class="mr-1 text-muted">phone</mat-icon>
                                N° de telephone</mat-label>
                                <input matInput placeholder="Email ou Tel : +33 ou +262.. " formControlName="email"  required>
                            <mat-error *ngIf="CreateUtilisateurForm.controls.email.errors?.required">Email ou N° de telephone
                                obligatoire</mat-error>
                            <mat-error *ngIf="CreateUtilisateurForm.controls.email.hasError('invalidEmail')">Invalid
                                Email ou N° de telephone</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100 mt-1">
                            <mat-icon matPrefix class="mr-1 text-muted">lock</mat-icon>
                            <mat-label>Mot de passe</mat-label>
                            <input matInput placeholder="Mot de passe" formControlName="password" type="password"
                                minlength="6" required [type]="hide ? 'password' : 'text'">
                            <mat-error *ngIf="CreateUtilisateurForm.controls.password.errors?.required">Password is
                                required</mat-error>
                            <mat-error *ngIf="CreateUtilisateurForm.controls.password.hasError('minlength')">Password
                                isn't long enough, minimum of 6 characters</mat-error>
                            <button mat-icon-button matSuffix (click)="hide = !hide" type="button" class="text-muted">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100 mt-1">
                            <mat-icon matPrefix class="mr-1 text-muted">lock</mat-icon>
                            <mat-label>Confirmation du mot de passe</mat-label>
                            <input matInput placeholder="Confirmation du mot de passe" formControlName="confirmPassword"
                                type="password" required [type]="hide ? 'password' : 'text'">
                            <mat-error *ngIf="CreateUtilisateurForm.controls.confirmPassword.errors?.required">Confirm
                                Password is required</mat-error>
                            <mat-error
                                *ngIf="CreateUtilisateurForm.controls.confirmPassword.hasError('mismatchedPasswords')">
                                Passwords do not match</mat-error>
                            <button mat-icon-button matSuffix (click)="hide = !hide" type="button" class="text-muted">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-slide-toggle formControlName="AceptCondition" required name="isAccept"
                             checked class="my-2"> <a mat-button (click)="readCGU()"
                                color="primary" class="mx-2">Accepter les Termes et conditions</a></mat-slide-toggle>
                        <mat-error *ngIf="CreateUtilisateurForm.controls.AceptCondition.errors?.required">Accepter les
                            termes et condition d\'utilisateurs </mat-error>
                        <mat-error *ngIf="CreateUtilisateurForm.controls.AceptCondition.hasError()">Invalid </mat-error>
                        <div class="text-center mt-2">
                            <button mat-raised-button color="accent" class="uppercase" type="submit">
                                Creer le compte
                            </button>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-3">
                            <div class="divider w-100"></div>
                            <h3 class="text-muted ws-nowrap fw-500 p-2">ou en un Click</h3>
                            <div class="divider w-100"></div>
                        </div>
                    </form>
                    <!-- les reseaux sociaux -->
                    <div class="text-center py-3">
                        <app-social-login></app-social-login>
        
                    </div>


                </div>
            </div>
        </mat-card>
    </div>
</div>
